export default "__VITE_ASSET__d_Fh0LlU__"